export const ERROR = 'error';
export const WARNING = 'warning';
export const INFO = 'info';
export const SUCCESS = 'success';

export default [ERROR, WARNING, INFO, SUCCESS];
